
import { nsTerminal } from '@/app/i18n/namespaces';
import { POS_TERMINALS } from '../../api/apiUrls';
import Entity from '@/common-utils/components/renders/entity/Entity';
import genUID from '@/common-utils/functions/generateUniqueId';

const MultipleBlockingPosImportProps = {
    apiUrl: POS_TERMINALS.BLACKLIST_MULTI_FILE_ACTION.url,
    namespace: nsTerminal,
    entityPrefix: 'modal.multiple_blocking_import',
    fileExampleProperties: {
        name: 'terminals_multi_blacklisting_example.csv',
        path: '/static/resource/files/terminals_multi_blacklisting_example.csv'
    },
    uploadProperties: {
        fileExtAccepted: ['.csv'],
        typeOfUpload: 'text',
        invalidFileEntity: 'modal.import.error.invalid_file'
    },
    countLines: (fileData) => {
        const fileLines = fileData.split('\n');
        const itemsSet = new Set();
        // Check column index of Serial number
        const columnIndex = fileLines && fileLines.length ? fileLines[0].split(';').findIndex((col) => col === 'Série') : null;

        // Count the number of terminals in the file if Serial Number column is found
        // Empty strings are not counted
        if (columnIndex !== null && columnIndex !== -1) {
            for (let i = 1; i < fileLines.length; i++) {
                // Prevent empty lines and empty cells
                if (fileLines[i] && fileLines[i].split(';')[columnIndex]) {
                    fileLines[i].split(';')[columnIndex].split(',').forEach((item) => {
                        if (item.trim()) {
                            itemsSet.add(item.toLowerCase().trim());
                        }
                    });
                }
            }
        }

        return { numberOfLines: itemsSet.size, file: { file: fileData } };
    },
    explanations: () => {
        return (<>
            <Entity entity='modal.multiple_blocking_import.explanations.header' namespace={nsTerminal} />
            <ul className='list-disc list-outside [&_ul]:list-[revert] ml-8'>
                <li><Entity entity='modal.multiple_blocking_import.explanations.organization' namespace={nsTerminal} /></li>
                <li><Entity entity='modal.multiple_blocking_import.explanations.serial_number' namespace={nsTerminal} /></li>
                <li><Entity entity='modal.multiple_blocking_import.explanations.direct_profider' namespace={nsTerminal} /></li >
                <li><Entity entity='modal.multiple_blocking_import.explanations.constructor' namespace={nsTerminal} /></li>
                <li><Entity entity='modal.multiple_blocking_import.explanations.label' namespace={nsTerminal} /></li>
                <li><Entity entity='modal.multiple_blocking_import.explanations.siret' namespace={nsTerminal} /></li>
            </ul>
            <div className='mt-4'>
                <Entity entity='modal.multiple_blocking_import.explanations.multiple_terminals' namespace={nsTerminal} />
            </div>
            <div className='mt-4'>
                <Entity entity='modal.multiple_blocking_import.explanations.warning' namespace={nsTerminal} />
            </div>
        </>);
    },
    confirmation: (numberOfLines) => {
        return <Entity
            entity='modal.multiple_blocking_import.confirmation'
            namespace={nsTerminal}
            data={{ numberOfTerminals: numberOfLines }}
        />;
    },
    isFileOnError: (fileDetails) => {
        return fileDetails?.errorsReport;
    },
    renderPostImportErrors: (fileDetails, error) => {
        const isCsvUploadOnError = error?.response?.data;
        if (isCsvUploadOnError) {
            const errorCode = error.response.data.errorCode;
            if (errorCode === 'BAD_FORMAT') {
                return (
                    <div>
                        <Entity entity='modal.multiple_blocking_import.error.BAD_FORMAT' namespace={nsTerminal} />
                        <br />
                        <br />
                        <Entity entity='modal.multiple_blocking_import.error.get_example_file' namespace={nsTerminal} />
                    </div>
                );
            } else if (errorCode === 'BAD_FILE_FORMAT') {
                return (
                    <div className='flex flex-col gap-2'>
                        <Entity
                            entity='modal.multiple_blocking_import.error.BAD_FILE_FORMAT'
                            namespace={nsTerminal}
                        />
                        <Entity
                            entity='modal.multiple_blocking_import.message'
                            namespace={nsTerminal}
                        />
                    </div>
                );
            }
            return (
                <Entity
                    entity='modal.multiple_blocking_import.error.UNEXPECTED_ERROR'
                    namespace={nsTerminal}
                />
            );
        }

        const isCsvContentOnError = fileDetails?.errorsReport;
        if (isCsvContentOnError) {
            return (
                <div>
                    {isCsvContentOnError.length > 0 &&
                        <div>
                            <Entity entity='modal.multiple_blocking_import.error.header' namespace={nsTerminal} />
                            <ul className='list-disc list-outside [&_ul]:list-[revert] my-4'>
                                {isCsvContentOnError.map((errorItem) => {
                                    return (
                                        <div key={genUID()}>
                                            <div>{errorItem.serialNumber ? errorItem.serialNumber : '-'}</div>
                                            <li className='ml-8'>
                                                <Entity entity={`modal.multiple_blocking_import.error.${errorItem.errorCode}`} namespace={nsTerminal} />
                                            </li>
                                        </div>
                                    );

                                })
                                }
                            </ul>
                            <Entity entity='modal.multiple_blocking_import.error.footer' namespace={nsTerminal} />
                        </div>
                    }
                </div>
            );
        }
    }
};

export default MultipleBlockingPosImportProps;